import { ProductAvailabilityGridDTO } from '../../../../modules/products/details/productDetails.types';
import { restApi } from '../../../api';
import { FindProductGridParams } from '../product-grid.types';

const PATH = 'orders';

export const onlineProductGridRepository = {
  findProductGrid: (params: FindProductGridParams) => {
    const { productColorId, availability, deliveryWindowId, orderId, kitId } = params;

    const urlParams = new URLSearchParams();
    urlParams.append('availability', availability);

    if (deliveryWindowId) {
      urlParams.append('deliveryWindowId', deliveryWindowId);
    }

    if (orderId) {
      urlParams.append('orderId', orderId);
    }

    if (kitId) {
      urlParams.append('kitId', kitId);
    }

    return restApi.get<ProductAvailabilityGridDTO[]>(
      `${PATH}/order-products/${productColorId}/grid-v2?${urlParams.toString()}`,
    );
  },
};
